// extracted by mini-css-extract-plugin
var _1 = "miniModalNotifications-module_dialog__cB0QZz";
var _2 = "miniModalNotifications-module_dialogContent__UTjD7S";
var _3 = "miniModalNotifications-module_dialogTitle__Kup2Mx";
var _4 = "miniModalNotifications-module_dialog_paper__C1uRVu";
var _5 = "miniModalNotifications-module_iconContainer__vkaS4e";
var _6 = "miniModalNotifications-module_listItemButton__MIYT7P";
var _7 = "miniModalNotifications-module_listItemText__XeNnjK";
var _8 = "miniModalNotifications-module_overlay__aojDzt";
export { _1 as "dialog", _2 as "dialogContent", _3 as "dialogTitle", _4 as "dialog_paper", _5 as "iconContainer", _6 as "listItemButton", _7 as "listItemText", _8 as "overlay" }
